import { toast } from "react-toastify";
import { ENTIDADES_API } from "../views/MainLayout/components/shared/services/clientes";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";


const initialState = {
    total_items: 0,
    clientes: [],
};

export const clientesReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'clientes/fullfilled':
            return action.payload;
        case 'clientes/add':
            if(state.clientes.length === 10 && state.total_items >= 10) {
                const newArr = [action.payload, ...state.clientes.slice(0, -1)]
                return {
                    ...state,
                    clientes: newArr
                }
            } else {
                return {
                    total_items: state.total_items + 1,
                    clientes: [action.payload, ...state.clientes]
                }
            } 
        case 'clientes/update':
            return {
                ...state,
                clientes: state.clientes.map(
                    (item) => item.id === action.payload.id ? action.payload : item 
                ),
            };

        default:
            return state;
    }
};

export const fetchClientes = (page, search) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await ENTIDADES_API.get(page, search)
        const data = await response.data;
        dispatch({ type: 'clientes/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}

export const addCliente = (newCliente) => ({
    type: 'clientes/add',
    payload: newCliente
})

export const updateCliente = (updatedCliente) => ({
    type: 'clientes/update',
    payload: updatedCliente
})